import React, { useEffect, useState } from 'react'
import { Card, Table, Button, Tag } from 'antd'
import { API } from 'src/utils/interceptor'
import Sentry from 'src/utils/sentry'
import { SuccessNotification } from 'src/notifications/SuccessNotification'
import DeclineReasonModal from './components/ui/DeclineReasonModal'

const SpecialPurchaseOrderDetail = () => {
  const searchParams = new URLSearchParams(location.search)
  const token = searchParams.get('token')

  const [order, setOrder] = useState(null)
  const [declineModalVisible, setDeclineModalVisible] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const handleApprove = async () => {
    await sendApproveAndDeclineStatus({
      isApproved: true,
      isDeclined: false,
      token,
    })
    setOrder({ ...order, isApproved: true, isDeclined: false })
  }

  const handleReject = () => {
    setDeclineModalVisible(true)
  }

  const handleDeclineConfirm = async declineReason => {
    setIsLoading(true)
    await sendApproveAndDeclineStatus({
      isApproved: false,
      isDeclined: true,
      declineReason,
      token,
    })
    setOrder({ ...order, isApproved: false, isDeclined: true })
    setDeclineModalVisible(false)
    setIsLoading(false)
  }

  const getPuchaseOrderDetail = async token => {
    try {
      const response = await API.get(
        'api2',
        `specialPuurchases/getPuchaseOrderDetail?token=${token}`,
      )

      if (response.success) {
        setOrder(response.data)
      }
    } catch (e) {
      console.error(e)
      Sentry.captureException(e)
      return false
    }
  }

  const sendApproveAndDeclineStatus = async data => {
    try {
      const response = await API.put(
        'api2',
        `specialPuurchases/sendApproveAndDeclineStatus`,
        { body: data },
      )

      if (response.success) {
        SuccessNotification({ message: response?.message })
      }
    } catch (e) {
      console.error(e)
      Sentry.captureException(e)
      return false
    }
  }

  useEffect(() => {
    if (token) {
      getPuchaseOrderDetail(token)
    }
  }, [token])

  const columns = [
    {
      title: 'Item Name',
      dataIndex: 'itemName',
      key: 'itemName',
    },
    {
      title: 'Item Cost',
      dataIndex: 'itemCost',
      key: 'itemCost',
      render: cost => `£${cost}`,
    },
    {
      title: 'Justification',
      dataIndex: 'justification',
      key: 'justification',
    },
    {
      title: 'Status',
      key: 'status',
      render: () =>
        order.isApproved ? (
          <Tag color='green'>Approved</Tag>
        ) : order.isDeclined ? (
          <Tag color='red'>Rejected</Tag>
        ) : (
          <Tag color='orange'>Pending</Tag>
        ),
    },
    ...(order?.isDeclined && order?.declineReason
      ? [
          {
            title: 'Decline Reason',
            dataIndex: 'declineReason',
            key: 'declineReason',
          },
        ]
      : []),
  ]
  if (order == null) return 'loading ...'
  return (
    <Card
      title='Order Details'
      bordered
      style={{ maxWidth: 800, margin: '20px auto' }}
    >
      <p>
        <strong>Manager:</strong> {order.managerDetails.managerName} (
        {order.managerDetails.managerEmail})
      </p>
      <p>
        <strong>Staff:</strong> {order.staffDetails.staffName} (
        {order.staffDetails.staffEmail})
      </p>
      <Table
        dataSource={[
          {
            ...order.itemDetails,
            justification: order.justification,
            declineReason: order.declineReason,
          },
        ]}
        columns={columns}
        pagination={false}
        rowKey='itemName'
      />

      <div style={{ marginTop: 20, textAlign: 'right' }}>
        <Button
          type='primary'
          onClick={handleApprove}
          style={{ marginRight: 10 }}
          disabled={order.isApproved}
        >
          Approve
        </Button>
        <Button
          type='danger'
          onClick={handleReject}
          disabled={order.isDeclined}
        >
          Reject
        </Button>
      </div>

      <DeclineReasonModal
        visible={declineModalVisible}
        onCancel={() => setDeclineModalVisible(false)}
        onConfirm={handleDeclineConfirm}
        loading={isLoading}
      />
    </Card>
  )
}

export default SpecialPurchaseOrderDetail
